import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/show_process/${packing_house_process_id}`
    );
  },

  fetchProcessLineStep(packing_house_id, process_line_step_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/show_step/${process_line_step_id}`
    );
  },

  fetchProcessLineExecStep(packing_house_id, process_line_exec_step_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_attr/fetch_process_line_exec_step/${process_line_exec_step_id}`
    );
  },

  fetchProcessLineStepAttrs(packing_house_id, process_line_step_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_attr/${process_line_step_id}/fetch_process_line_step_attrs`
    );
  },

  save(packing_house_id, process_line_exec_step_id, process_line_exec_attrs) {
    return RequesterV1.post(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_attr/save/${process_line_exec_step_id}`,
      { process_line_exec_attrs: process_line_exec_attrs }
    );
  },
};
